import React, { useContext } from "react"
import { Route, Switch } from "react-router-dom";
import AuthenticateUser from './Common/AuthenticateUser';
import { AuthDataContext } from './Common/AuthenticateUser';
import ThemeProvider from './Common/ThemeProvider';
import Login from './Login/Login';
import CreateInvoice from './SalesRep/CreateInvoice/Invoice';
import QuotationRecords from './QuotationRecords/QuotationRecord';
import Customers from './Customers/Customers';
import Products from './Products/Products';
import QApproval from './QuotationsApproval/QApproval';
import GenerateQuote from './GenerateQuotation/GenerateQuote';
import Dashboard from './DashBoard/Dashboard';
import InvoiceDashboard from './DashBoard/InvoiceDashboard';
import Profitability from './ProfitAnalyse/Profitability';
import Users from './Users/Users';
import QuotationHistory from './QuotationShapshot/QuotationSnapshot';
import PurchaseOrder from './PurchaseOrder/PurchaseOrder';
import PORecords from './PurchaseOrder/PORecords';
import GeneratePO from './GenerateQuotation/GeneratePO';
import POSnapshot from './QuotationShapshot/POSnapshot';
import FinalInvoice from './Invoice/FinalInvoice';
import InvoiceApproval from './Invoice/InvoiceApproval';
import GenerateInvoice from './Invoice/GenerateInvoice';
import InvoiceSnapshot from './Invoice/InvoiceSnapshot';
import InvoiceRecords from './Invoice/InvoiceRecords';
import CompanyInfo from './CompanyInfo/CompanyInfo';
import UserLeaves from './Users/UserLeaves';
import LeavesRecord from './Users/LeavesRecord';
import InvoiceNotes from './Invoice/InvoiceNotes';

import EmailSettings from './CompanyInfo/EmailSettings';
import InvoiceReminder from './Invoice/InvoiceReminder';
import CreditNotes from './Invoice/CreditNotes';
import RoleAccess from './Roles/RoleAccess';
import Roles from './Roles/Roles';
import Welcome from './Login/Welcome';
import CustomerDashboard from './DashBoard/CustomerDashboard';

import Organization from './Organization/Organization';
import MerchantCode from './ManageUser/MerchantCode';
import MerchantRewards from './ManageUser/MerchantRewards';
import NewEnquiry from './Enquiry/NewEnquiry';
import Enquiry from './Enquiry/Enquiry';
import Survey from './Enquiry/Survey';
import ManageSurvey from './Enquiry/ManageSurvey';
import TrackingDetails from './Tracking/TrackingDetails';
import Insurance from './Enquiry/Insurance';

import CreateLR from './LRDocument/CreateLR';
import GenerateLR from './LRDocument/GenerateLR';
import LRRecords from './LRDocument/LRRecords';
import IDCard from './ManageUser/IDCard';
import IBA from './IBA/IBA';
import InternalReq from './InternalServ/InternalReq';

import UserVerification from './ManageUser/UserVerification';
import ManageTrip from './Tracking/ManageTrip';

import AdminDashBoard from './DashBoard/AdminDashBoard';
import PartnerDashBoard from './DashBoard/PartnerDashBoard';
import Alert from './DashBoard/Alert';
import TrackRecords from './Tracking/TrackRecords';
import EBusinessCard from './ManageUser/EBusinessCard';

import TrackReport from './Reports/TrackReport';

import ErrorBoundary from './Common/ErrorBoundary';
import Event from './DashBoard/Event';
import EventRecords from './DashBoard/EventRecords';
import Calender from './DashBoard/Calender';
import EmailConfig from './Common/EmailService/EmailConfig';
import PartnerDirectory from './ManageUser/PartnerDirectory';
import IServRecords from './InternalServ/IServRecords';
import TrackLimits from "./TrackLimits/TrackLimits";

const PrivateRoute = ({ component, ...options }) => {
  const user = useContext(AuthDataContext);
  var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
  var authenticate = false;
  if (userData || user.userData.Authenticate) {

    authenticate = true;
  }

  const finalComponent = authenticate ? component : Login;
  return <Route {...options} component={finalComponent} />;
};

const Routes = () => {
  return (
    <AuthenticateUser>
      <ThemeProvider>
        <ErrorBoundary>
          <Switch>
            <Route exact path="/" component={Login} />
            <PrivateRoute exact path="/TrackReport" component={TrackReport} />
            <PrivateRoute Route path="/Welcome" component={Welcome} />
            <PrivateRoute path="/CreateQuotation" component={CreateInvoice} />
            <PrivateRoute path="/QuotationRecords" component={QuotationRecords} />
            <PrivateRoute path="/Customers" component={Customers} />
            <PrivateRoute path="/Products" component={Products} />
            <PrivateRoute path="/Users" component={Users} />
            <PrivateRoute path="/QuotationApproval" component={QApproval} />
            <PrivateRoute path="/GenerateQuotation/:QuoteID?" component={GenerateQuote} />
            <PrivateRoute path="/QuotationDashboard" component={Dashboard} />
            <PrivateRoute path="/InvoiceDashboard" component={InvoiceDashboard} />
            <PrivateRoute path="/ProfitMatrix" component={Profitability} />
            <PrivateRoute path="/QuotationHistory" component={QuotationHistory} />
            <PrivateRoute path="/PurchaseOrder" component={PurchaseOrder} />
            <PrivateRoute path="/PORecords" component={PORecords} />
            <PrivateRoute path="/GeneratePO" component={GeneratePO} />
            <PrivateRoute path="/POHistory" component={POSnapshot} />
            <PrivateRoute path="/Invoice" component={FinalInvoice} />
            <PrivateRoute path="/InvoiceApproval" component={InvoiceApproval} />
            <PrivateRoute path="/GenerateInvoice/:InvID?" component={GenerateInvoice} />
            <PrivateRoute path="/InvoiceHistory" component={InvoiceSnapshot} />
            <PrivateRoute path="/InvoiceRecords" component={InvoiceRecords} />
            <PrivateRoute path="/CompanyInfo" component={CompanyInfo} />
            <PrivateRoute path="/Leaves" component={UserLeaves} />
            <PrivateRoute path="/LeavesRecord" component={LeavesRecord} />
            <PrivateRoute path="/PaymentLogs" component={InvoiceNotes} />
            <PrivateRoute path="/EmailSettings" component={EmailSettings} />
            <PrivateRoute path="/Reminder" component={InvoiceReminder} />
            <PrivateRoute path="/CreditNotes" component={CreditNotes} />
            <PrivateRoute path="/RoleAccess" component={RoleAccess} />
            <PrivateRoute path="/Roles" component={Roles} />
            <PrivateRoute path="/CustomerDashboard" component={CustomerDashboard} />
            <PrivateRoute path="/Organization" component={Organization} />
            <PrivateRoute path="/MerchantCode" component={MerchantCode} />
            <PrivateRoute path="/Wallet" component={MerchantRewards} />
            <PrivateRoute path="/NewEnquiry" component={NewEnquiry} />
            <PrivateRoute path="/ManageEnquiry" component={Enquiry} />
            <PrivateRoute path="/Survey" component={Survey} />
            <PrivateRoute path="/ManageSurvey" component={ManageSurvey} />
            <PrivateRoute path="/Insurance" component={Insurance} />
            <PrivateRoute path="/CreateLR" component={CreateLR} />
            <PrivateRoute path="/GenerateLR" component={GenerateLR} />
            <PrivateRoute path="/LRRecords" component={LRRecords} />
            <PrivateRoute path="/IDCard" component={IDCard} />
            <PrivateRoute path="/InternalReq" component={InternalReq} />
            <PrivateRoute path="/IBA" component={IBA} />
            <PrivateRoute path="/ManageTrip" component={ManageTrip} />
            <PrivateRoute path="/AdminDashBoard" component={AdminDashBoard} />
            <PrivateRoute path="/PartnerDashBoard" component={PartnerDashBoard} />
            <PrivateRoute path="/Alert" component={Alert} />
            <PrivateRoute path="/TrackRecords" component={TrackRecords} />
            <Route path="/EBusinessCard/:id" component={EBusinessCard} />
            <Route path="/PartnerDirectory" component={PartnerDirectory}></Route>
            <Route path="/TrackingDetails/:trackId?" component={TrackingDetails} />
            <Route path="/UserVerification/:id" component={UserVerification} />
            <Route path="/Event" component={Event} />
            <Route path="/Calender" component={Calender} />

            <Route path="/EmailConfig" component={EmailConfig} />
            <Route path="/IServRecords" component={IServRecords} />
            <Route path="/TrackLimits" component={TrackLimits} />
            <Route path="/EventRecords" component={EventRecords} />

            <Route exact path="**" ren component={Login} />

          </Switch>
        </ErrorBoundary>
      </ThemeProvider>
    </AuthenticateUser>

  )
}

export default Routes